import { useEffect } from 'react';

export const useUpdateScreenHeight = () => {
  useEffect(() => {
    window.onresize = () => {
      window?.document.documentElement.style.setProperty('--screen-height', `${window.innerHeight}px`);
    };
  }, []);
};
